var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'hab-button',
    {
      [`${_vm.className}`]: _vm.className,
      [`theme-${_vm.theme}`]: _vm.theme,
      [`min-${_vm.min}`]: _vm.min,
      [`color-${_vm.color}`]: _vm.color,
      [`shape-${_vm.shape}`]: _vm.shape,
    },
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('span',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_vm._t("rightElement")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }